// import { stringify } from '@assets/utils/qs'
import { logWarning } from '@embed/helpers';
export class Performance {
    constructor({ key, app_id, widget_id, }) {
        this.prefix = (name) => `${this.key}/${name}`;
        this.mark = (name) => {
            try {
                window.performance && window.performance.mark(this.prefix(name));
            }
            catch (err) {
                logWarning(err);
            }
        };
        this.measure = (name, startMark, endMark) => {
            try {
                if (!window.performance) {
                    return;
                }
                const prefixedName = this.prefix(name);
                if (endMark && startMark) {
                    window.performance.measure(prefixedName, this.prefix(startMark), this.prefix(endMark));
                }
                else if (startMark) {
                    window.performance.measure(prefixedName, this.prefix(startMark));
                }
                else if (endMark) {
                    window.performance.measure(prefixedName, undefined, this.prefix(endMark));
                }
                else {
                    window.performance.measure(prefixedName);
                }
                window.performance
                    .getEntriesByName(prefixedName, 'measure')
                    .forEach((entry) => {
                    var _a, _b, _c;
                    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window._fwn) === null || _a === void 0 ? void 0 : _a.console) === null || _b === void 0 ? void 0 : _b.instance) === null || _c === void 0 ? void 0 : _c.log({
                        entry: Performance.formatMeasures(entry),
                        group: this.key,
                    });
                });
            }
            catch (err) {
                logWarning(err);
            }
        };
        this.key = key;
        this.app_id = app_id;
        this.widget_id = widget_id;
    }
}
Performance.roundAndPadNumber = (i) => {
    const decimals = 3;
    const divider = Math.pow(10, decimals);
    const seconds = Math.round(i) / divider;
    const split = `${seconds}`.split('.');
    return `${split[0]}.${(split[1] || '').padEnd(decimals, '0')}`;
};
Performance.formatMeasures = (entry) => {
    if (entry.startTime) {
        return (`${entry.name}` +
            ` at ${Performance.roundAndPadNumber(entry.startTime)}s` +
            ` took ${Performance.roundAndPadNumber(entry.duration)}s`);
    }
    else {
        return (`${entry.name}` +
            ` at ${Performance.roundAndPadNumber(entry.duration)}s`);
    }
};
const performanceFactory = (params) => {
    var _a;
    const key = Object.entries({
        app_id: params.app_id,
        channel: params.channel,
        channel_id: params.channel_id,
        hashtag: params.hashtag,
        playlist: params.playlist,
        video: params.video,
        widget_id: (_a = params.widget_id) === null || _a === void 0 ? void 0 : _a.substr(0, 8),
    })
        .filter(([, value]) => !!value)
        .map(([key, value]) => `${key}:${value}`)
        .join('/');
    window._fwnPerformance = window._fwnPerformance || {};
    return (window._fwnPerformance[key] =
        window._fwnPerformance[key] || new Performance(Object.assign({ key }, params)));
};
export default performanceFactory;
